import { createSelectorCreator, defaultMemoize } from 'reselect';
import isEqual from 'lodash.isequal';

// Selectors
import { selectFilteredData } from '../../../ReportsHarvestInspectionsTable/selectors';

const createDeepEqualSelector = createSelectorCreator(defaultMemoize, isEqual);

type State = *;

interface Props {
    field: string;
}

const selectField = (state: State, props: Props) => props.field;

const makeSelectFieldTotal = () =>
    createDeepEqualSelector(
        [selectFilteredData, selectField],
        (filteredDataState, fieldState) => {
            if (!filteredDataState || !filteredDataState.length) return '0';
            const total = filteredDataState.reduce(
                (acc, cur) => acc + cur[fieldState],
                0
            );
            return total.toLocaleString();
        }
    );

export { makeSelectFieldTotal };
